import { render, staticRenderFns } from "./ResellRightsForm.vue?vue&type=template&id=4ce9d56c&scoped=true"
import script from "./ResellRightsForm.vue?vue&type=script&lang=js"
export * from "./ResellRightsForm.vue?vue&type=script&lang=js"
import style0 from "./ResellRightsForm.vue?vue&type=style&index=0&id=4ce9d56c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce9d56c",
  null
  
)

export default component.exports